export function TrashIcon(): JSX.Element {
  return (
    <svg
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 16"
      width="15px"
      height="15px"
    >
      <path d="M9.33341 5.5V13.8333H2.66675V5.5H9.33341ZM8.08341 0.5H3.91675L3.08341 1.33333H0.166748V3H11.8334V1.33333H8.91675L8.08341 0.5ZM11.0001 3.83333H1.00008V13.8333C1.00008 14.75 1.75008 15.5 2.66675 15.5H9.33341C10.2501 15.5 11.0001 14.75 11.0001 13.8333V3.83333Z" />
    </svg>
  );
}
